import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { Star, Check, X, Trash2 } from 'lucide-react';
import { api } from '../../api/client';
import { toast } from 'sonner';

const Stars = ({ n }) => (
  <div className="flex gap-0.5">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className={`h-4 w-4 ${i < n ? 'text-[#d4af37] fill-[#d4af37]' : 'text-zinc-700'}`} />)}</div>
);

const AdminReviews = () => {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState('all');
  const [products, setProducts] = useState([]);

  const load = () => {
    const params = tab === 'pending' ? { approved: false } : tab === 'approved' ? { approved: true } : {};
    api.listReviews(params).then(setItems).catch(() => setItems([]));
  };
  useEffect(() => { api.listProducts().then(setProducts).catch(() => {}); }, []);
  useEffect(() => { load(); }, [tab]);

  const productName = (id) => products.find((p) => p.id === id)?.name || '—';

  const approve = async (id, approved) => { try { await api.approveReview(id, approved); toast.success(approved ? 'Approved' : 'Unapproved'); load(); } catch { toast.error('Failed'); } };
  const del = async (id) => { if (!window.confirm('Delete this review?')) return; try { await api.deleteReview(id); toast.success('Deleted'); load(); } catch { toast.error('Failed'); } };

  return (
    <div className="space-y-6">
      <p className="text-zinc-400 text-sm">Customer reviews on your products. Approve, hide or delete. Approved reviews appear on the product detail page.</p>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-zinc-900">
          <TabsTrigger value="all">All</TabsTrigger>
          <TabsTrigger value="approved">Approved</TabsTrigger>
          <TabsTrigger value="pending">Pending</TabsTrigger>
        </TabsList>
        <TabsContent value={tab} className="mt-6 space-y-3">
          {items.length === 0 && <p className="text-zinc-500 text-sm">No reviews in this segment yet.</p>}
          {items.map((r) => (
            <Card key={r.id} className="bg-zinc-950 border-zinc-900 p-5">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <Stars n={r.rating} />
                    <span className="text-zinc-100 font-medium">{r.title || '(no title)'}</span>
                    {r.verified_buyer && <Badge variant="outline" className="border-emerald-600 text-emerald-400 text-xs">Verified</Badge>}
                    {!r.approved && <Badge variant="outline" className="border-amber-600 text-amber-400 text-xs">Pending</Badge>}
                  </div>
                  <p className="text-zinc-300 text-sm">{r.body}</p>
                  <p className="text-zinc-500 text-xs mt-2">By <span className="text-zinc-300">{r.name}</span> on <span className="text-zinc-300">{productName(r.product_id)}</span> · {(r.created_at || '').slice(0, 10)}</p>
                </div>
                <div className="flex gap-1">
                  {r.approved
                    ? <Button size="sm" variant="ghost" className="text-zinc-300 hover:text-amber-400" onClick={() => approve(r.id, false)} title="Unapprove"><X className="h-4 w-4" /></Button>
                    : <Button size="sm" variant="ghost" className="text-zinc-300 hover:text-emerald-400" onClick={() => approve(r.id, true)} title="Approve"><Check className="h-4 w-4" /></Button>}
                  <Button size="sm" variant="ghost" className="text-zinc-300 hover:text-rose-500" onClick={() => del(r.id)}><Trash2 className="h-4 w-4" /></Button>
                </div>
              </div>
            </Card>
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminReviews;
